import React from 'react';
import {
  FormHelperText,
  Autocomplete,
  TextField,
  Tooltip,
  Box,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useUser } from '@/providers';

export default function DataConnectorsField({
  value,
  setValue,
  setChanged,
  edit,
}) {
  const user = useUser();
  const projectDataConnectors =
    useSelector((state) => state.projectDataConnectors) || [];

  const isDisabled = edit || !user.cloudbender_enabled;

  const options = projectDataConnectors.map((connector) => ({
    id: connector.connector_id,
    label: connector.name,
  }));

  const selectedValues = value
    ? value
        .map((connectorId) => {
          const connector = projectDataConnectors.find(
            (c) => c.connector_id === connectorId,
          );
          return connector
            ? { id: connector.connector_id, label: connector.name }
            : null;
        })
        .filter((v) => v !== null)
    : [];

  const handleChange = (event, newValue) => {
    const connectorIds = newValue.map((option) => option.id);
    if (JSON.stringify(connectorIds) !== JSON.stringify(value || [])) {
      setChanged();
    }
    setValue(connectorIds);
  };

  const field = (
    <Box>
      <Autocomplete
        multiple
        id='data-connectors'
        options={options}
        value={selectedValues}
        onChange={handleChange}
        disabled={isDisabled}
        disablePortal
        isOptionEqualToValue={(option, val) => option.id === val.id}
        getOptionLabel={(option) => option.label || ''}
        renderInput={(params) => (
          <TextField {...params} label='Data Connectors' />
        )}
      />
      <FormHelperText id='data-connectors-helper-text'>
        Select data connectors to attach to this job
      </FormHelperText>
    </Box>
  );

  if (isDisabled && !user.cloudbender_enabled) {
    return (
      <Tooltip title='Purchase a CloudBender subscription to enable this feature'>
        <span>{field}</span>
      </Tooltip>
    );
  }

  return field;
}
